if (!customElements.get('announcement-countdown')) {
  customElements.define(
    'announcement-countdown',
    class AnnouncementCountdown extends HTMLElement {
      connectedCallback() {
        this.endTime = parseInt(this.dataset.end, 10) * 1000;
        this.timer = this.querySelector('.announcement-countdown__timer');
        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.values[el.dataset.unit] = el;
        });
        if (!this.endTime || !this.timer) return;
        this.tick();
        this.interval = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      tick() {
        const remaining = this.endTime - Date.now();
        if (remaining <= 0) {
          window.clearInterval(this.interval);
          this.timer.classList.add('hidden');
          const inEditor = window.Shopify && window.Shopify.designMode;
          if (this.dataset.hideWhenEnded === 'true' && !inEditor) this.hidden = true;
          return;
        }
        const total = Math.floor(remaining / 1000);
        const parts = {
          days: Math.floor(total / 86400),
          hours: Math.floor((total % 86400) / 3600),
          minutes: Math.floor((total % 3600) / 60),
          seconds: total % 60,
        };
        Object.keys(parts).forEach((unit) => {
          const el = this.values[unit];
          if (el) el.textContent = String(parts[unit]).padStart(2, '0');
        });
        this.timer.classList.remove('hidden');
      }
    }
  );
}
